import { render, staticRenderFns } from "./account-owner-transfer.vue?vue&type=template&id=3ca65c58"
import script from "./account-owner-transfer.vue?vue&type=script&lang=ts"
export * from "./account-owner-transfer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports